import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Chip,
  IconButton,
  Rating,
  Stack,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchKeys } from "../../lib/redux/slices/searchKeysSlice";
import { fetchWorker } from "../../lib/redux/slices/workerSlice";
import MobileViewSearchModel from "./MobileViewSearchModel";
import { t } from "i18next";

const MobileViewSearch = () => {
  const openSearchDialog = useRef(null);
  const dispatch = useDispatch();
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);
  const subServiceId = useSelector(
    (state) => state.activeSubServiceIdReducer.subServiceId
  );

  const handleReset = async (e) => {
    e.stopPropagation();
    if (subServiceId) {
      let lat = "";
      let lng = "";

      const query = {
        serviceId: subServiceId,
        lat: lat,
        lng: lng,
        name: "",
        rating: "",
        date: "",
      };

      dispatch(fetchWorker(query));
      dispatch(
        setSearchKeys({
          ...searchKeys,
          workerNameSmall: "",
          workerRatingSmall: 0,
          workerLocationSmall: null,
          workerDateTimeSmall: null,
        })
      );
    }
  };

  return (
    <Box px={1} width={"100%"} display={{ xs: "block", sm: "none", }}>
      <Stack
        mt={1}
        gap={1}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"center"}
        borderRadius={10}
        border={"0.5px solid rgba(0,0,0,0.08)"}
        boxShadow={"0 6px 20px 0 rgba(0,0,0,0.1)"}
        width={"100%"}
        p={1}
        sx={{ cursor: "pointer" }}
        onClick={() => openSearchDialog.current.openDialog()}
        position={"relative"}
      >
        <SearchIcon fontSize="small" />
        <Typography fontStyle={"italic"} fontWeight={500}>
          {t('startYourSearch')}
        </Typography>

        <IconButton
          onClick={handleReset}
          sx={{
            position: "absolute",
            right: "10px",
            padding: "5px",
            backgroundColor: "primary.main",
            "&:hover": {
              backgroundColor: "primary.main",
            },
          }}
        >
          <RestartAltIcon htmlColor="white" />
        </IconButton>
      </Stack>

      {/* <Stack direction={"row"} mt={1} gap={1} flexWrap={"wrap"}>
        {searchKeys?.workerNameSmall && (
          <Chip label={searchKeys?.workerNameSmall} />
        )}
        {searchKeys?.workerLocationSmall && (
          <Chip label={searchKeys?.workerLocationSmall?.address} />
        )}
        {searchKeys?.workerRatingSmall > 0 && (
          <Chip
            label={<Rating value={searchKeys?.workerRatingSmall} readOnly />}
          />
        )}
        {searchKeys?.workerDateTimeSmall && (
          <Chip
            label={moment(searchKeys?.workerDateTimeSmall).format(
              "DD-MM-YY hh:mm a"
            )}
          />
        )}
      </Stack> */}

      <MobileViewSearchModel
        ref={openSearchDialog}
        selectedService={subServiceId}
      />
    </Box>
  );
};

export default MobileViewSearch;
